import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Star, ArrowUpRight } from "lucide-react";
import { api, fileUrl } from "@/lib/api";
import { IMAGES } from "@/lib/images";
import { Reveal } from "@/components/primitives";

export function useFoundingMembers() {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/founding-members").then((r) => setData(r.data)).catch(() => setData({ properties: [], count: 0, target: 20 }));
  }, []);
  return data;
}

export function FoundingCard({ p, index = 0 }) {
  return (
    <Reveal delay={(index % 3) * 0.1}>
      <Link to={`/collection/${p.slug}`} className="group block" data-testid={`founding-card-${p.slug}`}>
        <div className="relative aspect-[4/5] overflow-hidden">
          <img
            src={p.hero_image ? fileUrl(p.hero_image) : IMAGES.amalfiVilla2}
            alt={p.name}
            className="w-full h-full object-cover transition-transform duration-[1200ms] ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-navy-900/70 via-transparent to-transparent" />
          <span className="absolute top-4 left-4 inline-flex items-center gap-1.5 bg-navy-900/75 backdrop-blur text-gold text-[9px] tracking-[0.2em] uppercase px-3 py-1.5 border border-gold/40">
            <Star size={11} className="fill-gold" /> Founding Member
          </span>
          <ArrowUpRight size={18} className="absolute top-4 right-4 text-ivory/0 group-hover:text-ivory transition-colors duration-500" />
        </div>
        <div className="mt-6">
          <span className="text-[10px] tracking-[0.25em] uppercase text-gold">VillaFlow Selected Property</span>
          <h3 className="font-serif text-2xl md:text-3xl text-ivory mt-2 group-hover:text-gold transition-colors duration-500">{p.name}</h3>
          <p className="text-ivory/50 text-sm mt-1 font-light">{p.location}</p>
        </div>
      </Link>
    </Reveal>
  );
}
